import { render, staticRenderFns } from "./dialogDetail1.vue?vue&type=template&id=0422571c&scoped=true&"
import script from "./dialogDetail1.vue?vue&type=script&lang=ts&"
export * from "./dialogDetail1.vue?vue&type=script&lang=ts&"
import style0 from "./dialogDetail1.vue?vue&type=style&index=0&id=0422571c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0422571c",
  null
  
)

export default component.exports